module.exports = __webpack_public_path__ + "static/Korero_RecruitPro_Thumbnail1-e2ff03559ec764a385ec0362d33b1d11.jpg";